import type {
  EntnahmeReasonInput,
  EntnahmeReasonsResponse,
  EntnahmeReasonsSaveResponse,
} from '@/api/types'
import { apiRequest } from '@/api/client'

export const entnahmeReasonsApi = {
  get: (restaurantId: number) =>
    apiRequest<EntnahmeReasonsResponse>(
      `/api/v0/admin/entnahme-reasons/${restaurantId}`,
    ),
  save: (restaurantId: number, items: Array<EntnahmeReasonInput>) =>
    apiRequest<EntnahmeReasonsSaveResponse>(
      `/api/v0/admin/entnahme-reasons/${restaurantId}`,
      {
        method: 'PUT',
        body: JSON.stringify({ items }),
      },
    ),
}
